import _ from 'underscore';
import { View } from 'backbone';
import messages from 'messages';
import Settings from './settings_model';

const BaseView = View.extend({
    defaults: {},
    template() {
        return '<span></span>';
    },
    model: {},
    initialize(options) {
        this.options = _.extend(this.defaults, options);
        this.router = options.router;
        this.el = this.options.el || this.el;
        this.template = this.options.template || this.template;
        this.model = this.options.model || this.model;
        this.render();
    },
    events: {
        'component:all:redirect': 'redirectTo'
    },
    serializeModel(model) {
        const modelForParse = model || this.model;
        const isPlainObject = !_.isFunction(modelForParse.toJSON);
        return isPlainObject ? modelForParse : modelForParse.toJSON();
    },
    render(model) {
        const context = _.extend({ msgs: messages },
                                 Settings.get(),
                                 this.serializeModel(model));
        const rendered = this.template(context);
        this.$el.html(rendered);
        return rendered;
    },
    redirectTo({ url }) {
        if (this.router) {
            this.router.routeByUrl(url);
        } else {
            this.routeByUrl(url);
        }
    },
    routeByUrl(url) {
        window.location.href = url;
    },
    createChild(ChildView, options) {
        const child = new ChildView(options);

        this.children = this.children || {};
        this.children[child.cid] = child;
        child.parent = this;
        return child;
    },
    remove(isParentCall) {
        if (this.parent && !isParentCall) {
            this.parent.removeChild(this);
        }
        View.prototype.remove.call(this);
    },
    removeChildren() {
        _.each(this.children, (child) => {
            if (child) {
                child.removeCildren();
                child.remove(true);
            }
        });
    },
    removeChild(child) {
        if (_.isFunction(child.removeChildren)) {
            child.removeChildren();
            child.remove(true);
        }
        delete this.children[child.cid];
    }
});

export default BaseView;



// WEBPACK FOOTER //
// ./static-source/js/lib/base_view.js